import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { Button, Result } from 'antd'
import { useLoadedInit } from 'utils/hooks'
import useMemoizeCheckPermission from 'utils/hooks/useMemoizeCheckPermission'
import useNavigation from 'utils/hooks/useNavigation'

function RestrictedPage({ children, code, restricted, subTitle }) {
  const { formatMessage } = useIntl()
  const { onNavigate } = useNavigation()
  const isHasAccessDashboard = useMemoizeCheckPermission({ permission: 'dashboard' })
  const isHasAccess = useMemoizeCheckPermission({ permission: code })
  const loadedInit = useLoadedInit()

  const goToDashboard = useCallback(() => onNavigate('/dashboard'), [onNavigate])

  if (loadedInit && (restricted || (code && !isHasAccess))) {
    return (
      <Result
        status="403"
        title="403"
        subTitle={
          subTitle ||
          formatMessage({
            id: 'message.sorry_you_are_not_authorized_to_access_this_page',
          })
        }
        extra={
          isHasAccessDashboard ? (
            <Button onClick={goToDashboard} type="primary">
              {formatMessage({ id: 'companies.go_to_dashboard' })}
            </Button>
          ) : null
        }
      />
    )
  }
  return children
}

export default RestrictedPage
